import jwt from "jwt-decode"

const userInfo = () => {
  const token = () => localStorage.getItem("token")

  return token() !== "" && token() ? jwt(token()) : {}
}

export default userInfo
